import {FC, useContext, useEffect, useState} from 'react'
import {Accordion, Button, Form} from 'react-bootstrap'
import {getRoles} from '../../../../../services/rol'
import {updateUserByUnitsXPerfilMany} from '../../../../../services/users'
import {showMessage} from '../../../../../shared/Alerts'
import {PartnerContext} from '../../PartnerContexts'
import {UserItem} from './UserItem'

interface MyComponentProps {
  users: {[key: string]: any}[]
  onCheckSelect: (Ids: string[]) => void
}

const UnitByRoleFinal: FC<MyComponentProps> = (props) => {
  const [rolesDb, setRolesDb] = useState<any[]>([])
  const {tabUnitRole} = useContext(PartnerContext)
  const {users, onCheckSelect} = props
  const [selectedIds, setSelectedIds] = useState<string[]>([])
  const [updatedUsers, setUpdatedUsers] = useState<any[]>([])
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    setSelectedIds((prev) => prev.filter((id) => users.some((u) => u._id === id)))
  }, [users])

  const handleCheck = (id: string, checked: boolean) => {
    let updatedIds: string[]
    if (checked) {
      updatedIds = [...selectedIds, id]
    } else {
      updatedIds = selectedIds.filter((itemId) => itemId !== id)
    }
    setSelectedIds(updatedIds)
    onCheckSelect(updatedIds)
  }

  const handleUpdateMany = async () => {
    const usersToJsonBody = updatedUsers.map((user) => ({
      userUpdatedId: user.id,
      data: user.roleUnidad,
    }))

    try {
      setIsLoading(true)
      const response = await updateUserByUnitsXPerfilMany(usersToJsonBody)

      if (response.success) {
        showMessage(
          'success',
          'Se actualizaron correctamente',
          'Los usuarios se actualizaron correctamente'
        )
      } else {
        showMessage('error', 'Hubo un error', 'Hubo un error al actualizar los usuarios')
      }
    } catch (err) {
      showMessage('error', 'Hubo un error', 'Hubo un error al actualizar los usuarios')
    } finally {
      setIsLoading(false)
    }
  }

  const handleUserUpdate = (user: any) => {
    setUpdatedUsers((prev) => {
      const exists = prev.find((u) => u.dni === user.dni)
      if (exists) {
        return prev.map((u) => (u.dni === user.dni ? user : u))
      }
      return [...prev, user]
    })
  }

  useEffect(() => {
    getRoles()
      .then((response) => {
        if (response.success) {
          setRolesDb(response.data)
        } else {
          showMessage('error', 'Error al obtener roles', 'No se pudieron obtener los roles')
        }
      })
      .catch((err) => {
        showMessage('error', 'Error al obtener roles', (err as Error).message)
      })
  }, [])

  return (
    <>
      <div className='my-3'>
        <Form.Check
          type='checkbox'
          inline
          label='Selecionar todos'
          checked={users.length === 0 ? false : users.every((u) => selectedIds.includes(u._id))}
          onChange={(e) => {
            const isChecked = e.target.checked
            const ids = isChecked ? users.map((x) => x._id) : []
            setSelectedIds(ids)
            onCheckSelect(ids)
          }}
        />
        <Button
          variant='success'
          onClick={handleUpdateMany}
          disabled={isLoading || users.length < 2}
        >
          Actualizar todos
        </Button>
      </div>

      <Accordion alwaysOpen>
        {users.map((user) => {
          const unidades: any[] = user.unidad.filter(
            (unidad: any) => unidad.codEmpresa === tabUnitRole.companyId
          )
          const roles: any[] =
            user?.roles?.find((rol: any) => rol.empresa === tabUnitRole.companyId)?.rol ?? []
          const rolesValues = roles.map((r) => {
            const roleDb = rolesDb.find((rb) => rb.rol === r)
            return {
              id: r,
              name: roleDb.nombre_perfil,
            }
          })

          return (
            <UserItem
              key={user._id}
              checked={selectedIds.includes(user._id)}
              onCheck={(checked: boolean) => handleCheck(user._id, checked)}
              id={user._id}
              dni={user.dni}
              nombre={user.nombre}
              companyId={tabUnitRole.companyId}
              roles={rolesValues}
              unidades={unidades}
              rolesUnidad={
                user?.roles_unidad?.find((ru: any) => ru.company === tabUnitRole.companyId) ?? null
              }
              rolesUnidadFull={user?.roles_unidad ?? []}
              onUserUpdate={handleUserUpdate}
            />
          )
        })}
      </Accordion>
    </>
  )
}

export {UnitByRoleFinal}
